/**
 * OverlayStack.jsx
 * ─────────────────────────────────────────────────────────────
 * IJ:       IJ-256 · Phase 5G · Overlay Stack Aggregator (LAST Phase 5 slice)
 * Date:     2026-08-02
 * Umbrella: IJ-076 · Refactor Programme 2026 · Phase 5G
 * Owner:    E1
 *
 * Purpose:
 *   Aggregate four modal-overlay component invocations that sit at the
 *   bottom of KnowledgeGraphPage.jsx (below the footer) into a single
 *   composition component. Byte-verbatim on every prop pass-through.
 *   Zero behaviour change.
 *
 * Overlays aggregated (in DOM order · call-order preserved):
 *   1. CitationModal          · citation source viewer
 *   2. ReindexPromptModal     · Knowledge Atlas incremental reindex prompt
 *   3. ImageLightbox          · full-screen image viewer
 *   4. PolicyModals           · Ethics · Terms · Privacy · AI Risk modals
 *
 * NOT aggregated by this slice (preserved above the footer for byte-
 * verbatim DOM call-order):
 *   - ControlCentre
 *   - MenuOverlay
 *   - SafeBrowser
 *   A future micro-slice may extend this aggregator to cover them.
 *
 * Props (14):
 *   citationModal · setCitationModal · handleDownloadSourceDocument
 *   reindexPrompt · reindexRunning · reindexProgress
 *   handleReindexConfirm · handleReindexSkip
 *   lightbox · setLightbox
 *   activePolicyModal · setActivePolicyModal · setShowMenu · setMenuView
 */
import React from 'react';
import { CitationModal } from './CitationModal';
import ReindexPromptModal from './ReindexPromptModal';
import ImageLightbox from './ImageLightbox';
import PolicyModals from './PolicyModals';

export function OverlayStack({
  citationModal, setCitationModal, handleDownloadSourceDocument,
  reindexPrompt, reindexRunning, reindexProgress,
  handleReindexConfirm, handleReindexSkip,
  lightbox, setLightbox,
  activePolicyModal, setActivePolicyModal, setShowMenu, setMenuView,
}) {
  return (
    <>
      {/* Citation Source Modal - Extracted Component */}
      <CitationModal 
        citationModal={citationModal}
        onClose={() => setCitationModal(null)}
        onDownload={handleDownloadSourceDocument}
      />

      {/* Knowledge Atlas Incremental Reindex Prompt.
          Fires on the "New artefact(s) uploaded" event per operator
          request (Mockup v0.6, 2026-07-06). Copy is operator-verbatim.
          Extracted into components/app/ReindexPromptModal.jsx (Phase E). */}
      <ReindexPromptModal
        reindexPrompt={reindexPrompt}
        reindexRunning={reindexRunning}
        reindexProgress={reindexProgress}
        onConfirm={handleReindexConfirm}
        onSkip={handleReindexSkip}
      />

      {/* Image Lightbox — extracted into components/app/ImageLightbox.jsx (Phase E) */}
      <ImageLightbox
        lightbox={lightbox}
        onClose={() => setLightbox(null)}
      />

      {/* Policy Modals — extracted into components/app/PolicyModals.jsx (Phase E) */}
      <PolicyModals
        activePolicyModal={activePolicyModal}
        setActivePolicyModal={setActivePolicyModal}
        onOpenRevenueTerms={() => {
          setActivePolicyModal(null);
          setShowMenu(true);
          setMenuView('revenue-terms');
        }}
      />
    </>
  );
}
